import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "../../styles/code/HeroSection.css";

const images = [
  "/images/code/code-slide-1.webp",
  "/images/code/code-slide-2.webp",
];

function HeroSection() {
  return (
    <section className="code-hero">
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        spaceBetween={0}
        centeredSlides={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        navigation={false}
        className="code-hero__swiper"
      >
        {images.map((src, index) => (
          <SwiperSlide key={index}>
            <div
              className="code-hero__slide"
              style={{ backgroundImage: `url(${src})` }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default HeroSection;
